// extracted by mini-css-extract-plugin
export default {"root":"PaymentInformationBlock_root-Skz","safeBlock":"PaymentInformationBlock_safeBlock-Exd","rows":"PaymentInformationBlock_rows-Qkn","list":"PaymentInformationBlock_list-onI"};